import {useState} from "react";


export default function MobPressable({ children, onClick,disabled, style = {},fastClick }) {
    const [pressed, setPressed] = useState(false)

    let _disabled=disabled || !onClick
    let _style={}
    if(!_disabled){
        _style={cursor:"pointer",userSelect:"none",transition: "opacity 0.2s ease, transform 0.1s ease", opacity: pressed ? 0.6 : 1,transform: pressed ? "scale(0.95)" : "scale(1)"}
    }

    return (
        <div
            onMouseDown={() => {
                if(!_disabled && onClick && fastClick){
                    //onClick()
                }
                setPressed(true)
            }}
            onMouseUp={() => setPressed(false)}
            onMouseLeave={() => setPressed(false)}
            onTouchStart={() => {
                if(!_disabled && onClick && fastClick){
                    //onClick()
                }
                setPressed(true)
            }}
            onTouchEnd={() => setPressed(false)}
            onClick={_disabled?null:onClick}
            style={{...style,..._style}}
        >
            {children}
        </div>
    )
}
